export default "__VITE_ASSET__1a2ea0e1__"